<script>
  import Icon from "./Icon.svelte";
  import widgetStore from 'store/widget';

  let name = $widgetStore.business_name || 'PressOne';
</script>
<div class="absolute bottom-0 w-full">
  <div class="flex bg-white">
    <div class="flex mb-3 justify-center items-center w-full text-gray-500 text-xs">
      Powered by
      <span class="footer-logo">
        <Icon icon="brand-logo-3" size="40" />
      </span>
    </div>
    <div class="flex absolute left-0 right-0 bottom-0 h-2 footer-bg-color"></div>
  </div>
</div>

<style>
  .footer-logo {
    background-color: #fff;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-left: 5px;
    margin-bottom: 8px;
  }

  .footer-bg-color {
    background: var(--primary-bg-color);
  }
</style>
